




















import Vue, { PropType } from 'vue'
export default Vue.extend({
	props: {
		title: String as PropType<string>,
		gradientPreset: String as PropType<string>,
		gradientStart: String as PropType<string>,
		gradientEnd: String as PropType<string>,
		imageSrc: String as PropType<string>,
      firstName: String as PropType<string>,
      lastName: String as PropType<string>,
      occupation: String as PropType<string>
	},

	data() { return {
		gradient: {
			start: "",
			end: ""
		}
	}},

	watch: {
		gradientPreset() {
			this.setGradientPreset();
		}
	},

	beforeMount() {
		if (this.gradientPreset) {
			this.setGradientPreset();
		}
		else {
			this.gradient.start = this.gradientStart;
			this.gradient.end = this.gradientEnd;
		}
	},

	computed: {
		gradientBoxStyles() : any {
			return {
				background: `linear-gradient(180deg, ${this.gradient.start} 0%, ${this.gradient.end} 100%)`
			}
		}
	},
	
	methods: {
		setGradientPreset() {
			if (this.gradientPreset == "tp-person") {
				this.gradient.start = "#2f5dde";
				this.gradient.end = "#0062ff";
			}
		}
	}
})
